<template>
  <div id="faq-page" style="margin-top: 60px">
    <AppHead :title="seoTitle">
      <meta
        :name="page.name"
        :content="page.content"
        v-for="(page, index) in page.data.seos"
        :key="index"
      />
    </AppHead>
    <section id="hero-image" v-if="banners.data[0]">
      <img
        class="img-fluid w-100 h-hero-image"
        :src="banners.data[0].image_desktop"
        :alt="banners.data[0].image_desktop.split('/').slice(banners.data[0].image_desktop.split('/').length-1)[0].split('.')[0]"
      />
    </section>
    <section class="container">
      <nav style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb" class="mt-4 py-2">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><Link :href="route('home.index', { lang: getLocale() })" class="text-black">{{__('Beranda')}}</Link></li>
          <li class="breadcrumb-item active" aria-current="page">FAQ</li>
        </ol>
      </nav>
    </section>
    <section id="content" class="container pb-5 pt-3">
      <div class="row">
        <div class="col-lg-3 side-menu-faq mb-4">
          <Link
            :href="
              route('information.faq.show', {
                lang: getLocale(),
                faqtype: theFaqType.slug,
              })
            "
            class="btn w-100 text-start rounded-custom px-4 py-2 mb-1"
            :class="{ active: theFaqType.id == faqtype.id }"
            v-for="theFaqType in faqtypes.data"
            :key="theFaqType.id"
          >
            {{ theFaqType.name }}
          </Link>
        </div>
        <div class="col-lg-9">
          <div class="title mb-3">
            <h1>
              <span class="fw-bold"> OK BANK </span>
              Indonesia
            </h1>
          </div>
          <div class="accordion" id="accordion-faq" style="border-radius: 8px">
            <div
              class="accordion-item mb-2"
              v-for="(faq, index) in faqs.data"
              :key="faq.id"
            >
              <h2 class="accordion-header" :id="`heading-${faq.id}`">
                <button
                  class="accordion-button fw-bold"
                  :class="{ collapsed: index != 0 }"
                  type="button"
                  data-bs-toggle="collapse"
                  :data-bs-target="`#collapse-${faq.id}`"
                  aria-expanded="false"
                  :aria-controls="`collapse-${faq.id}`"
                >
                  {{ faq.title }}
                </button>
              </h2>
              <div
                :id="`collapse-${faq.id}`"
                class="accordion-collapse collapse"
                :class="{ show: index == 0 }"
                :aria-labelledby="`heading-${faq.id}`"
                data-bs-parent="#accordion-faq"
              >
                <div class="accordion-body px-4" v-html="faq.description">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
import Layout from "@/Shared/Layout";


export default {
  layout: Layout,
  props: {
    faqtypes: Object,
    faqtype: Object,
    faqs: Object,
    page: Object,
    banners: Object,
    seoTitle: String,
  },
  components: {

  },
  mounted() {
  },
};
</script>
